var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/object-is-prototype-of.js
// module id = 2219
// module chunks = 0